export const getFormatMoney = x => {
  // Hàm dùng format tiền theo chuẩn chuẩn : 3 số là thêm dấu chấm
  if (x) {
    const parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(".");
  }
  return 0;
};
